export default {"src":"/_next/static/media/Logo.eaf59df9.svg","height":48,"width":131};